"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeviceDisplaySwitch = void 0;
var _react = _interopRequireDefault(require("react"));
var _layoutGrid_on = _interopRequireDefault(require("../../icons/layout-grid_on.svg"));
var _list_on = _interopRequireDefault(require("../../icons/list_on.svg"));
var _constants = require("../../utils/constants");
var _material = require("@mui/material");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const notActiveBtnOpacity = 0.3;
const DeviceDisplaySwitch = _ref => {
  let {
    typeDisplay,
    setTypeDisplay
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      display: 'flex',
      gap: 2
    }
  }, /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    sx: {
      opacity: typeDisplay === _constants.contentType.layoutGrid ? 1 : notActiveBtnOpacity
    },
    onClick: () => setTypeDisplay(_constants.contentType.layoutGrid)
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _layoutGrid_on.default,
    alt: ""
  })), /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    sx: {
      opacity: typeDisplay === _constants.contentType.table ? 1 : notActiveBtnOpacity
    },
    onClick: () => setTypeDisplay(_constants.contentType.table)
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _list_on.default,
    alt: ""
  })));
};
exports.DeviceDisplaySwitch = DeviceDisplaySwitch;
DeviceDisplaySwitch.propTypes = {
  typeDisplay: _propTypes.default.oneOf([_constants.contentType.layoutGrid, _constants.contentType.table]),
  setTypeDisplay: _propTypes.default.func.isRequired
};
DeviceDisplaySwitch.defaultProps = {
  typeDisplay: _constants.contentType.layoutGrid
};